/**
 * 화장장 퍼널 진입 컨텍스트.
 *
 * 화장장 상세 페이지 → /match/request/?template=crematorium&crematorium_id={id} 로 넘어올 때
 * 화장장 ID를 세션에 저장한다. 개장이장 종료 화면에서 해당 화장장 전화번호를 보여주는 데 쓴다.
 *
 * 탭 단위(sessionStorage)라 탭을 닫으면 지워진다.
 * matchRequestNeedsContext, regionLoginContext 와 같은 패턴.
 */

const CREMATORIUM_ENTRY_KEY = "crematorium_entry_id";

/**
 * 화장장 ID를 세션에 마킹한다.
 * @param id - router.query.crematorium_id (string | string[] | undefined)
 */
export const markCrematoriumEntry = (id: string | string[] | undefined) => {
  if (typeof window === "undefined") return;
  if (typeof id !== "string") return;
  try {
    sessionStorage.setItem(CREMATORIUM_ENTRY_KEY, id);
  } catch {
    // Safari private 등 쓰기 실패. 없으면 fallback 안내로 흐른다
  }
};

/**
 * 저장된 화장장 ID를 읽는다.
 * @returns 화장장 ID 문자열, 없으면 null
 */
export const getCrematoriumEntryId = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(CREMATORIUM_ENTRY_KEY);
  } catch {
    return null;
  }
};
